import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import TokensList from "./views/TokensList";
import * as tokensActions from "../../../../redux/modules/tokens";
import * as optionsActions from "../../../../redux/modules/options";

const mapStateToProps = state => {
  return {
    loading: state.tokens.loading,
    success: state.tokens.success,
    message: state.tokens.message,
    data: state.tokens.data,
    total: state.tokens.total,
    limit: state.tokens.limit,
    page: state.tokens.page,
    order: state.tokens.order,
    orderMode: state.tokens.orderMode,
    deleted: state.tokens.deleted,
    deletedId: state.tokens.deletedId,
    token: state.tokens.token,

    headerLoaded: state.options.headerLoaded,
    translate: state.options.translate,
    searchModel: state.options.searchModel,
    columns: state.options.columns,
    columnsOrder: state.options.columnsOrder,
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getListHeader: optionsActions.getGridInfo,
      optionsReset: optionsActions.reset,

      getList: tokensActions.tokensList,
      delete: tokensActions.tokenDelete,
      setLoading: tokensActions.setLoading
      //reset: tokensActions.reset
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TokensList);
